export interface INetworkEmailSender {
    isIndividual: boolean,
    emailAddress: {
        address: string,
        displayName: string
    }
}